<h4  class="text-center" mat-dialog-title>😎 Are you sure, you to delete this page ?</h4>
<mat-dialog-actions>
    <div class="col-12 text-center">
        <button type="button" (click)="deletePage()"  mat-dialog-close style="background-color: rgb(167, 167, 167);border-color: rgb(167, 167, 167);" class="btn  btn-secondary btn-template ">Yes</button>
        <button type="button"   mat-dialog-close  class="btn  btn-secondary button-top btn-template ml-3" >No</button>
    </div>
</mat-dialog-actions>